<template lang="pug">
    v-card.haq-dialog-card
        v-card-title
            v-row
                v-col(:cols="12" :sm="12")
                    h5 Select Measurements
                v-col(:cols="12" :md="5")
                    HaqTextField(v-model="zoneSearchQuery" append-icon="mdi-magnify" label="Search Zones" hide-details ref="searchBarZone")
                v-col(:cols="12" :md="5").ml-12
                    HaqTextField(v-model="measurementSearchQuery" append-icon="mdi-magnify" label="Search Measurements" hide-details ref="searchBarMeasurement")
        v-card-text(v-if="structuredMeasurements == null").d-flex.justify-center
            v-progress-circular(indeterminate color="primary")
        v-card-text(v-else)
            .optionsDiv
                .zoneDiv
                    .option
                        v-subheader.pa-0.ma-0 Zones
                    .option.pa-2.mt-2.show-hover(@click="toggleMultiselect")
                        v-icon mdi-checkbox-multiple-marked-outline
                        .optionTitle Multiselect by Type
                    .option.pa-2.mt-2.show-hover(v-if="showMultiselect" v-for="type in loadedPointTypes" :key="type" @click="selectedTypes[type] = !selectedTypes[type]; selectAllOfType()").my-0
                        v-checkbox(v-model="selectedTypes[type]" hide-details :label="type" @click="selectAllOfType()" @click.stop).ma-0
                    .option.pa-2.mt-2.show-hover(@click="setZone(siteId)")
                        v-icon mdi-domain
                        .optionTitle Site Measurements
                    .option.pa-2.mt-.show-hover(v-for="z in zones" :key="z.id" v-show="showThisZone(z)" @click="setZone(z.id)" v-bind:class="{'active': selected == z.id}")
                        v-icon mdi-home-group
                        .optionTitle {{z.name}}
                .measurementDiv
                    .option
                        v-subheader.pa-0.mx-0.ml-4 Measurements
                    .option.pa-2.mt-2.show-hover(v-for="m,index in structuredMeasurements" :key="m.objectId" v-show="showThisMeasurement(m, getDisplayName(m))" :data-measurement-id="m.objectId" :data-measurement-index="index" @click="m.selected = !m.selected").my-0
                        v-checkbox(v-model="m.selected" hide-details :label="getDisplayName(m)" @click.stop).ma-0
        v-card-actions.mt-auto.ml-auto
            v-btn.haq-btn.haq-btn-secondary(@click="$emit('closeModal')").mr-4 Cancel
            v-btn.haq-btn.haq-btn-primary(:disabled="structuredMeasurements == null" @click="addMeasurements") Confirm
</template>
<script>
import { err_code } from 'redis/lib/utils';
import { useGetSite } from '../../assets/js/hawken-query';
import {HTTPClient} from "../../assets/js/http"
import HaqTextField from '@/components/form/HaqTextField.vue';
let client = new HTTPClient();
export default {
    name: "MultiMeasurementSelector",
    components: {
        HaqTextField
    },
    props: {
        preSelectedMeasurements: { type: Array, default: () => [] },
        reportSiteId: String,
        source: String,
    },
    data(){
        return {
            zones: [],
            site: null,
            measurementForTopology: [],
            structuredMeasurements: null,
            selected: this.reportSiteId || this.$route.query.siteId || this.$route.params.siteId,
            siteId: this.reportSiteId || this.$route.query.siteId || this.$route.params.siteId,
            measurementSearchQuery: "",
            zoneSearchQuery: "",
            selectedMeasurements: {},
            includeAll: {},
            loadedPointTypes: [], // New array to track all types of loaded points
            selectedTypes: {},
            showMultiselect: false
        }
    },
    methods: {
        setZone(e){
            this.selected = e;
        },
        toggleMultiselect() {
            this.showMultiselect = !this.showMultiselect;
        },
        selectAllOfType() {
            this.structuredMeasurements.forEach(m => {
                m.selected = this.selectedTypes[m.type];
            });
        },
        async loadstructuredMeasurements(){
            try {
                let measurements = [];
                let res;
                if(this.source == null){
                    res = await client.robustQuery(`/api/sites/reports/${this.siteId}/measurements`, {includeScores: true});
                    console.log("Source null ", res)
                } else if(this.source == "schedule"){
                    res = await client.robustQuery(`/api/sites/${this.siteId}/scheduleGroups/measurements`, {includeScores: true, structured: true});
                    console.log("Source schedule ", res)
                } else {
                    throw Error("Invalid source")
                }
                for(let z in res.results.zones){
                    let zone = res.results.zones[z];
                    if (zone.measurements) {
                        zone.measurements.sort((a, b) => 
                            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
                        );
                        // Add types from zone measurements to loadedPointTypes
                        zone.measurements.forEach(m => {
                            if (!this.loadedPointTypes.includes(m.type)) {
                                this.loadedPointTypes.push(m.type);
                                this.selectedTypes[m.type] = false;
                            }
                        });
                    }
                    this.zones.push({
                        name: zone.name,
                        id: z,
                    })
                    measurements = measurements.concat(zone.measurements)
                }
                // Sort zones alphabetically by name (case-insensitive)
                this.zones.sort((a, b) => 
                    a.name.toLowerCase().localeCompare(b.name.toLowerCase())
                );
                // Sort loadedPointTypes alphabetically by name (case-insensitive)
                this.loadedPointTypes.sort((a, b) => 
                    a.toLowerCase().localeCompare(b.toLowerCase())
                );
                measurements = measurements.concat(res.results.site.measurements)
                // Add types from site measurements to loadedPointTypes
                res.results.site.measurements.forEach(m => {
                    if (!this.loadedPointTypes.includes(m.type)) {
                        this.loadedPointTypes.push(m.type);
                        this.selectedTypes[m.type] = false;
                    }
                });
                const selectedIds = new Set(this.preSelectedMeasurements.map(point => typeof point === 'string' ? point : point.id || point.objectId));
                measurements.forEach(el => {
                    el.selected = selectedIds.has(el.objectId);
                });
                this.structuredMeasurements = measurements;
                console.log('zones', this.zones)
            } catch (error) {
                console.error(error);
            }
        },
        addMeasurements(){
            let selectedMeasurements = this.structuredMeasurements.filter((el) => el.selected).map((el) => {
                return {
                    id: el.objectId,
                    type: el.type,
                    uuid: el.uuid,
                    name: el.name,
                    zoneName: el.zone?.name
                }
            })
            this.$emit("addMeasurements", selectedMeasurements);
        }
    },
    mounted(){
        this.loadstructuredMeasurements()
        this.$refs.searchBarZone.$el.querySelector("input")?.classList.add("browser-default")
        this.$refs.searchBarMeasurement.$el.querySelector("input")?.classList.add("browser-default")
    },
    computed: {
        getDisplayName(){
            return (m) => {
                if(m.type == "scoreAQ"){
                    return "Air Quality Score"
                } else if(m.type == "scoreEQ"){
                    return "Equipment Score"
                } else if(m.type == "scoreOW"){
                    return "Occupant Wellness Score"
                } else if(m.type == "scoreOA"){
                    return "Overall Score"
                } else if(m.type == "scoreAF"){
                    return "Air Freshness Score"
                } else {
                    return m.name + " " + (m.unit ? `(${m.unit})` : "")
                }
            }
        },
        showThisMeasurement(){
            return (m, dn) => {
                let regex = new RegExp(this.measurementSearchQuery, "i")
                if(this.selected == this.siteId){
                    return m.zone == null && (regex.test(m.name) || regex.test(m.type) || regex.test(m.unit) || regex.test(dn))
                } 
                else {
                    return m.zone?.objectId === this.selected && (regex.test(m.name) || regex.test(m.type) || regex.test(m.unit) || regex.test(dn))
                }
            }
        },
        showThisZone(){
            return (z) => {
                if (!this.zoneSearchQuery) return true;
                let regex = new RegExp(this.zoneSearchQuery, "i")
                return regex.test(z.name)
            }
        }
    },
}
</script>
<style lang="sass" scoped>
.v-card__actions
    padding: 20px 24px !important
    
    .haq-btn
        border-radius: 12px !important
        padding: 8px 24px !important
        font-weight: 500 !important
        text-transform: none !important
        min-width: 100px !important
        height: 2.8em !important
        line-height: 2.8em !important
        
        &.haq-btn-primary
            background: var(--score-blue-color) !important
            color: white !important
            
            &:hover
                background: var(--score-blue-color) !important
                opacity: 0.9 !important
                
            &:disabled
                background: var(--app-tertiary-bg) !important
                color: var(--app-tertiary-txt) !important
                opacity: 0.6 !important
        
        &.haq-btn-secondary
            background: var(--app-tertiary-bg) !important
            color: var(--app-primary-txt) !important
            border: 1px solid var(--border) !important
            
            .v-btn__content
                color: var(--app-primary-txt) !important
            
            &:hover
                background: var(--app-secondary-bg) !important
</style>